import { useMemo } from 'react'
import { useWidgetContext } from '../../../context/WidgetContext';
import { DocIframe } from '../../common/DocIframe';
import { AIChatAgent } from '../../ai-chatagent/AIChatAgent';
import { SpeechConversationPanel } from '../../ai-chatagent/SpeechConversationPanel';
import { SearchPanel } from '../../ai-chatagent/SearchPanel';
import { ImagePanel } from '../../ai-chatagent/ImagePanel';
import { VideoPanel } from '../../ai-chatagent/VideoPanel';
import { CodePanel } from '../../ai-chatagent/CodePanel';
import { ChatContextProvider } from '../../../context/ChatContext';
import { CloseButton } from '../button/CloseButton';
import { isFullscreenWidgetMode } from '../../../types/agent-mode';

export const PanelContainer = () => {
  const {
    isDocActive,
    isApiActive,
    isAIOpen,
    isModeFullscreen,
    agent,
    mode,
  } = useWidgetContext();

  const isSpeechModal = mode === 'speech' && isModeFullscreen
  const isSearchModal = mode === 'search' && isModeFullscreen
  const isImageModal = mode === 'image' && isModeFullscreen
  const isVideoModal = mode === 'video' && isModeFullscreen
  const isFullscreenModal = isFullscreenWidgetMode(mode) && isModeFullscreen

  const aiModeLabel = useMemo(() => {
    if (mode === 'search') return 'Search'
    if (mode === 'code') return 'Code'
    if (mode === 'image') return 'Image'
    if (mode === 'video') return 'Video'
    if (mode === 'speech') return 'Speech'
    return 'AI'
  }, [mode])

  const fullscreenTitle = useMemo(() => {
    if (mode === 'search') return 'Search Mode'
    if (mode === 'speech') return 'Speech Mode'
    if (mode === 'code') return 'Code Mode'
    if (mode === 'image') return 'Image Mode'
    if (mode === 'video') return 'Video Mode'
    return 'AI Mode'
  }, [mode])

  return (
    <div className={`osirus-agent-panel ${isFullscreenModal ? 'speech-fullscreen' : ''}`}>
      <div className='osirus-agent-panel-header'>
        {isFullscreenModal ? (
          <>
            <div className="osirus-agent-panel-header-left" />
            <div className="osirus-agent-panel-modal-title">
              {fullscreenTitle}
            </div>
            <CloseButton />
          </>
        ) : (
          <>
            <CloseButton />
            { isAIOpen && (
              <>
              <div className='osirus-agent-panel-name'>
                <div>
                  <span className='osirus-agent-panel-ai-tag'>{aiModeLabel}</span>
                  <span>{agent.companyName || agent.name || 'Customer Support Agent'}</span>
                </div>
              </div>
              </>
            )}
          </>
        )}
      </div>
      {isAIOpen && (
        <>
          {isSpeechModal && <SpeechConversationPanel />}
          {mode === 'search' && <SearchPanel />}
          {mode === 'code' && <CodePanel />}
          {(mode === 'image' || isImageModal) && <ImagePanel />}
          {(mode === 'video' || isVideoModal) && <VideoPanel />}
          {!isFullscreenModal && mode === 'chat' && (
            <ChatContextProvider>
              <AIChatAgent mode={mode} />
            </ChatContextProvider>
          )}
        </>
      )}
      {(isDocActive && agent.docUrl) && (
        <DocIframe src={agent.docUrl} />
      )}
      {(isApiActive && agent.apiDocUrl) && (
        <DocIframe src={agent.apiDocUrl} />
      )}
    </div>
  )
}
